import React from 'react';
import { Moon, Sun, Pill, Dumbbell, Brain, Heart, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
const learningPoints = [{
  icon: <Moon className="w-7 h-7 text-emerald-600" data-id="element-142" />,
  text: 'Cómo reprogramar tu ritmo circadiano para dormir profundo y levantarte con energía.'
}, {
  icon: <Sun className="w-7 h-7 text-amber-500" data-id="element-143" />,
  text: 'La forma correcta de usar la luz solar y la oscuridad para equilibrar tus hormonas.'
}, {
  icon: <Pill className="w-7 h-7 text-blue-500" data-id="element-144" />,
  text: 'Qué nutrientes como el omega-3, magnesio y vitamina D realmente hacen la diferencia en esta etapa.'
}, {
  icon: <Dumbbell className="w-7 h-7 text-rose-500" data-id="element-145" />,
  text: 'Cómo fortalecer tu masa muscular y proteger tus huesos con rutinas simples y efectivas.'
}, {
  icon: <Brain className="w-7 h-7 text-purple-500" data-id="element-146" />,
  text: 'Ganar claridad mental y equilibrio emocional.'
}, {
  icon: <Heart className="w-7 h-7 text-red-500" data-id="element-147" />,
  text: 'Los secretos de tu microbiota intestinal y cómo impacta en tu energía, tu digestión y tus emociones.'
}];
export function LearnSection() {
  return <section className="py-16 md:py-24 bg-white px-5 border-b border-gray-100" data-id="element-148">
      <div className="max-w-5xl mx-auto" data-id="element-149">
        <div className="text-center mb-12 md:mb-16 max-w-3xl mx-auto" data-id="element-150">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-50 text-emerald-800 text-xs font-bold tracking-wider uppercase mb-6 border border-emerald-100" data-id="element-151">
            <Sparkles className="w-3 h-3" data-id="element-152" />
            Guía Práctica Incluida
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-6 leading-tight tracking-tight" data-id="element-153">
            Todo lo que vas a aprender para transformar tu bienestar
          </h2>
          <p className="text-lg md:text-xl text-gray-600 leading-relaxed" data-id="element-154">
            Un programa integral diseñado para acompañarte en la pre y
            postmenopausia.
          </p>
        </div>

        <div className="space-y-4 md:space-y-0 md:grid md:grid-cols-2 md:gap-5 mb-12 md:mb-16" data-id="element-155">
          {learningPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="flex items-start gap-4 p-5 rounded-2xl border border-gray-100 hover:border-emerald-100 transition-colors bg-white" data-id="element-156">
              <div className="shrink-0 p-2.5 bg-gray-50 rounded-xl border border-gray-100" data-id="element-157">
                {point.icon}
              </div>
              <div className="flex-1 pt-1" data-id="element-158">
                <p className="text-gray-700 font-medium leading-relaxed text-base md:text-lg" data-id="element-159">
                  {point.text}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center bg-emerald-600 rounded-2xl p-8 md:p-10 max-w-3xl mx-auto relative overflow-hidden" data-id="element-160">
          <p className="text-lg md:text-2xl font-medium text-white italic relative z-10 font-serif leading-relaxed" data-id="element-161">
            "Todo con estrategias simples, fáciles de aplicar y con resultados
            visibles en pocas semanas."
          </p>
        </div>
      </div>
    </section>;
}